import { render, staticRenderFns } from "./RevisionDetail.vue?vue&type=template&id=bd23b4c2"
import script from "./RevisionDetail.vue?vue&type=script&lang=js"
export * from "./RevisionDetail.vue?vue&type=script&lang=js"
import style0 from "./RevisionDetail.vue?vue&type=style&index=0&id=bd23b4c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports